import {
    CopyOutlined,
    EnvironmentFilled,
    LinkOutlined,
} from "@ant-design/icons";
import { Button, Flex, Image } from "antd";
import { type FC, type ReactNode, useMemo } from "react";
import { Market } from "tm-shared/types";

import { PrimaryText } from "@/components/Typography/Styled";
import { copyObjectToClipboard } from "@/utils/dom/copyObjectToClipboard";
import { getFileUrl } from "@/utils/file/getFileUrl";

import {
    StyledCard,
    StyledCardContent,
    StyledChainIndicator,
    StyledImgWrapper,
} from "./Styled";

export interface MarketCardBaseProps {
    market: Market;
    status?: "archived" | "hasRoutes" | null;
    isChild?: boolean;
    bottomSlot?: ReactNode;
}

export const MarketCardBase: FC<MarketCardBaseProps> = ({
    market,
    status,
    isChild,
    bottomSlot,
}) => {
    const { address, photo, name, title } = market;

    const handleOpenPointMap = () => {
        const currentAddress = market?.geo ?? address?.name;

        window.open(
            `https://www.google.com/maps/place/${currentAddress?.replace(
                /\s/gi,
                "+",
            )}`,
        );
    };

    const marketToCopy = useMemo(
        () => ({
            id: market.id,
            name: market.name,
            externalMarketId: market.externalMarketId,
            address: market.address.name,
            partner: market.partner.name,
            type: market.type,
            category: market.category,
            contragent: market.contragent,
            hasDebt: market.hasDebt,
            hasDebtCritical: market.hasDebtCritical,
        }),
        [market],
    );

    return (
        <StyledCard $status={status ?? undefined}>
            {isChild && (
                <StyledChainIndicator>
                    <LinkOutlined />
                </StyledChainIndicator>
            )}

            <StyledCardContent>
                <Flex align="center" gap={10}>
                    <StyledImgWrapper>
                        <Image src={getFileUrl(photo)} />
                    </StyledImgWrapper>

                    <Button
                        onClick={handleOpenPointMap}
                        type="text"
                        icon={<EnvironmentFilled style={{ fontSize: 22 }} />}
                    />

                    <Button
                        onClick={() => copyObjectToClipboard(marketToCopy)}
                        type="text"
                        icon={<CopyOutlined style={{ fontSize: 22 }} />}
                    />

                    {status === "archived" && (
                        <PrimaryText
                            $textColor="error"
                            style={{ marginLeft: "auto" }}
                        >
                            Архівна
                        </PrimaryText>
                    )}
                </Flex>

                <Flex vertical gap={4}>
                    {title && (
                        <PrimaryText $textColor="disabled">{title}</PrimaryText>
                    )}

                    <PrimaryText $textColor="disabled">{name}</PrimaryText>
                </Flex>

                {bottomSlot}
            </StyledCardContent>
        </StyledCard>
    );
};
